<rk-modal-wrapper
  [showSubmitBlock]="false"
  [showHeader]="false"
  [slideshow]="true"
  (closed)="close(true)"
>
  <div class="close" (click)="close(true)">
    <mat-icon fontSet="fa" fontIcon="fa-times"></mat-icon>
  </div>
  <div class="main">
    <div class="content">
      <ng-container *ngIf="$step()">
        <div class="slide flex flex-col items-center">
          @if ($step().video) {
            <div class="gif cursor-pointer" (click)="playVideo()">
              <img src="/assets/slideshow/{{ $step().src }}" [alt]="$step().title" />
            </div>
            <div class="absolute top-[143px] pointer-events-none">
              <img src="/assets/icons/play-video.svg" alt="Play video" />
            </div>
          } @else {
            <div class="gif text-center">
              <img src="/assets/slideshow/{{ $step().src }}" [alt]="$step().title" />
            </div>
          }
          <rk-step-indicator
            [steps]="steps.length"
            [activeStep]="currentStep"
          ></rk-step-indicator>
          <div class="slide-desc self-start">
            <div class="slide-title mb-1">
              {{ $step().title }}
            </div>
            <div class="slide-content" [innerHTML]="$step().description"></div>
          </div>
        </div>
      </ng-container>

      <div class="menu-actions flex justify-end">
        <rk-button
          [label]="'SLIDESHOW.PREV' | translate"
          [btnStyle]="'orange'"
          [disabled]="currentStep === 0"
          (click)="prevStep()"
        ></rk-button>
        @if (currentStep < steps.length - 1) {
          <rk-button
            [label]="'SLIDESHOW.NEXT' | translate"
            (click)="nextStep()"
          ></rk-button>
        } @else {
          <rk-button
            [label]="'SLIDESHOW.DISCOVER' | translate"
            (click)="close()"
          ></rk-button>
        }
      </div>
    </div>
  </div>
</rk-modal-wrapper>
